import { SvgIconProps } from "../types";
import { assetUrl } from "../utils/assetUrl";

/** "48px" → 48, so we can emit the intrinsic attribute and avoid layout shift. */
const toAttr = (value: string): number | undefined => {
  const match = /^(\d+(?:\.\d+)?)px$/.exec(value.trim());
  return match ? Number(match[1]) : undefined;
};

/**
 * Thin wrapper over the images in /public/img/svg.
 *
 * Two fixes over the original: `alt` defaults to empty instead of the filename
 * (screen readers were announcing "GetItOnGooglePlay.png"), and non-pixel sizes
 * like "auto" are applied as CSS rather than as invalid width/height
 * attributes.
 */
export const SvgIcon = ({
  src,
  width,
  height,
  alt = "",
  className,
}: SvgIconProps) => (
  <img
    src={assetUrl(`/img/svg/${src}`)}
    alt={alt}
    width={toAttr(width)}
    height={toAttr(height)}
    loading="lazy"
    decoding="async"
    className={className}
    style={{ width, height }}
  />
);

export default SvgIcon;
